/*
*自定义js文件
*/

const PRODUCT_OPTION_DATA={
  standard_dimensions_selected:'',
  non_standard_dimensions_selected:'',
  dimensions_type:'',
  main_product_selected:'',
  thickness_selected:'',
  install_service_selected:'',
};
const PRICE={
  mainProduct:'',
  dimensions:'',
  thickness:'',
  service:'',
  totlePrice:'',
};


document.addEventListener("DOMContentLoaded",event=>{
  async function getCart(){
    const response_cart_data = await fetch(window.Shopify.routes.root + 'cart.json');
    return await response_cart_data.json()  
  }
  //更新头部购物车角标
  getCart().then(data=>{
    const cartCount = document.querySelector("[data-cart-count]");
    let count = 0;
    data.items.forEach(el=>{
      if(el.properties.type=="product") count = count + 1;
    });
    cartCount.innerHTML = count;
    return count
  });
});



class ProductPage {
  constructor(options){
    this.options = options;
  }
}

class SuperQuantitySelector extends HTMLElement{
  constructor(){
    super();
    this.selectorButtons = this.querySelectorAll(".super-quality button");
    this.input = this.querySelector(".super-quality-input");
    this.selectorButtons.forEach(el=>{
      el.addEventListener("click",event=>{
        event.preventDefault();
        const buttonType = el.getAttribute("type");
        if(buttonType == 'plus'){
            this.input.value = Number(this.input.value) + 1 > 0 ? Number(this.input.value) + 1 : 1;
        }else if(buttonType == 'minus'){
            this.input.value = Number(this.input.value) - 1 > 0 ? Number(this.input.value) - 1 : 1;
        }
        this.syncInput();
        //更改价格
      })
    });

    
    this.input.addEventListener("change",event=>{
      if(this.input.value < 1){
        this.input.value = 1;
      }
      this.syncInput();
      //更改价格
    });
    
    
  }

  syncInput(){
    document.querySelector("[data-quantity-value]").value = this.input.value;
  }

  
}

customElements.define("super-quality",SuperQuantitySelector)



//移除购物车
class RemoveCart extends HTMLElement{
  constructor(){
    super();
    
  }

  connectedCallback(){
    this.removeBtn = this.querySelector(".cart-trash");
    this.cartId = this.getAttribute("cart-id");
    this.type = this.getAttribute("type");
    this.removeBtn.addEventListener("click",event=>{
      event.preventDefault();
      if(this.type == 'mini'){
        this.loading(document.querySelector(".mini-cart-loading"));
        this.removeCart(this.cartId);
      }else{
        this.loading(this.closest(".main-cart-title").querySelector(".mini-cart-loading"));
        this.removeMainCart(this.cartId);
      }
    });
  }

  async removeCart(cartId){
    const carts = await this.getCart();
    const cart_index = [];
    const cartsNew = carts.items.filter((item,index)=>{
      if(item.properties._cart_id==cartId){
        cart_index.push(index+1);
        return item;
      }
    });
    let remove_count = 0;
    for (let [index,line] of cart_index.entries()){
      line = line - remove_count;
      remove_count = remove_count + 1;
      await this.changeCartProduct(line,0);
    }
    //刷新cart
    await this.getCartElement();
  }

  async removeMainCart(cartId){
    const carts = await this.getCart();
    const cart_index = [];
    const cartsNew = carts.items.filter((item,index)=>{
      if(item.properties._cart_id==cartId){
        cart_index.push(index+1);
        return item;
      }
    });
    let remove_count = 0;
    for (let [index,line] of cart_index.entries()){
      line = line - remove_count;
      remove_count = remove_count + 1;
      await this.changeCartProduct(line,0);
    }
    //刷新 main cart
    await this.getMainCartElement();
  }

  async getCart(){
    const response_cart_data = await fetch(window.Shopify.routes.root + 'cart.json');
    return await response_cart_data.json()  
  }

  async changeCartProduct(line,quality){
    if(typeof(line) != 'string'){
      line = line.toString();
    }
    const formData ={
      'line': line,
      'quantity': quality
    }
    const response_data = await fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    });
    return await response_data.json();
  }

  async getMainCartElement(){
    const section_id = this.getAttribute("section-id");
    const response_data = await fetch(window.Shopify.routes.root + `?section_id=${section_id}`);
    const parser = new DOMParser();
    const responseHTML = parser.parseFromString(await response_data.text(), 'text/html');
    const insertHTML = responseHTML.querySelector(".t4s-main-cart").innerHTML;
    const cartEl = document.querySelector(".t4s-main-cart");
    cartEl.innerHTML = insertHTML;
    await this.openMiniCart(cartEl);
    return await response_data
  }

  async getCartElement(){
    const response_data = await fetch(window.Shopify.routes.root + '?section_id=mini_cart');
    const parser = new DOMParser();
    const responseHTML = parser.parseFromString(await response_data.text(), 'text/html');
    const insertHTML = responseHTML.querySelector("#shopify-section-mini_cart").innerHTML;
    const cartEl = document.querySelector("#t4s-mini_cart");
    cartEl.innerHTML = insertHTML;
    await this.openMiniCart(cartEl);
    return await response_data
  }

  async openMiniCart(el){
    //更新购物车角标
    const carts = await this.getCart();
    const line_nums = carts.items.filter(item=>{
      if(item.properties.type == 'product'){
        return item
      }
    });
    document.querySelector("[data-cart-count]").innerHTML = line_nums.length;
    el.setAttribute('aria-hidden',false);
    //监听关闭购物车事件
    document.querySelector(".t4s-drawer__close").addEventListener("click",event=>{
      el.setAttribute('aria-hidden',true);
    })
    // setTimeout(()=>{
    //   console.log(document.querySelector(".t4s-site-nav__cart [data-drawer-options]"));
    //   document.querySelector(".t4s-site-nav__cart [data-drawer-options]").click();
    // },0)
    
  }

  loading(element){
    element.classList.remove("hidden");
  }
  
}

customElements.define("remove-cart",RemoveCart)

//自定义加购组件
class SuperBuy extends HTMLElement{
  constructor(){
    super();
    this.quality = this.getQualityElement();
    this.variantPicker = this.getVariantPickerElement();
    this.addCard = this.querySelector("#button-add-to-card") ? this.querySelector("#button-add-to-card") : null;
    this.buyNow = this.querySelector("#button-buy-now") ? this.querySelector("#button-buy-now") : null;
    if(this.addCard){
      this.addCard.addEventListener("click",event=>{
        //切换按钮状态
        this.loading(event.currentTarget);
        //加入购物车
        this.addToCard(event);
      })
    };
    if(this.buyNow){
      this.buyNow.addEventListener("click",event=>{
        this.loading(event.currentTarget);
        this.buyItNow(event);
      })
    }
  }

  loading(element){
    element.querySelector(".super-buy-button-text").classList.add("hidden");
    element.querySelector(".loading").classList.remove("hidden");
  }

  loaded(element){
    element.querySelector(".loading").classList.add("hidden");
    element.querySelector(".super-buy-button-text").classList.remove("hidden");
  }

  async addToCard(event,buyNow=false){
    const mainProductSelected = this.variantPicker.mainProductCurrentSelect;
    const dimensionSelected = this.variantPicker.getDimensionProductVariants();
    const optionSelected = this.variantPicker.getOptionProductVariants();
    
    console.log("选项产品：",optionSelected);
    
    const quality = this.getQualityElement().input.value;
    const time = new Date().getTime();
    //清空购物车
    const carts = await this.getCart();
    let hasMain = false;
    for(const cart of carts.items){
      if(cart.properties.type=='product'){
        hasMain = true;
      }
    };
    if(!hasMain){
      await this.clearCart();
    };    
    
    //加入主产品
    await this.addCart(mainProductSelected.p_id,mainProductSelected.variant_id,quality,"product",time);
    //加入尺寸
    for (const item of dimensionSelected){
      await this.addCart(item.product_id,item.variant_id,quality,"option",time);
    }
    //加入选项产品
    for (const item of optionSelected){
      await this.addCart(item.product_id,item.variant_id,quality,"option",time);
    }

    //更新按钮状态
    this.loaded(event.target);
    await this.getCart();
    //打开购物车
    //获取购物车代码
    if(!buyNow){
      await this.getCartElement()
    }
    
    
  }

  async buyItNow(event){
    await this.addToCard(event,true);
    window.location.href = "/checkout";
    
  }

  //get variant picker component
  getVariantPickerElement(){
    return document.querySelector("super-variant-picker");
  }

  getQualityElement(){
    return document.querySelector("super-quality");
  }

  async addCart(productId,variantId,quality,type,time){
    let formData = {
      "form_type": "product",
      "utf8": "✓",
      "id": variantId,//加入购物车的产品的属性的id
      "quantity": quality,//加入购物车产品的数量
      "product-id": productId,//加入购物车产品的id
      "properties":{"type":type,"_cart_id":time},
    };
    const response=await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    return await response.json();
  }

  async getCart(){
    const response_cart_data = await fetch(window.Shopify.routes.root + 'cart.json');
    return await response_cart_data.json()  
  }

  async changeCartProduct(variantId,quality){
    const formData ={
      'id': variantId,
      'quantity': quality
    }
    const response_data = await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      body: formData
    });
    return await response_data.json();
  }

  async clearCart(){
    const response_data = await fetch(window.Shopify.routes.root + 'cart/clear.js');
    return await response_data.json() 
  }

  async getCartElement(){
    const response_data = await fetch(window.Shopify.routes.root + '?section_id=mini_cart');
    const parser = new DOMParser();
    const responseHTML = parser.parseFromString(await response_data.text(), 'text/html');
    const insertHTML = responseHTML.querySelector("#shopify-section-mini_cart").innerHTML;
    const cartEl = document.querySelector("#t4s-mini_cart");
    cartEl.innerHTML = insertHTML;
    await this.openMiniCart(cartEl);
    return await response_data
  }

  async openMiniCart(el){
    //更新购物车角标
    const carts = await this.getCart();
    const line_nums = carts.items.filter(item=>{
      if(item.properties.type == 'product'){
        return item
      }
    });
    document.querySelector("[data-cart-count]").innerHTML = line_nums.length;
    el.setAttribute('aria-hidden',false);
    //监听关闭购物车事件
    document.querySelector(".t4s-drawer__close").addEventListener("click",event=>{
      el.setAttribute('aria-hidden',true);
    })
    // setTimeout(()=>{
    //   console.log(document.querySelector(".t4s-site-nav__cart [data-drawer-options]"));
    //   document.querySelector(".t4s-site-nav__cart [data-drawer-options]").click();
    // },0)
    
  }
  
}

customElements.define("super-buy",SuperBuy)


//自定义多变体选择器组件
class SuperVariantPicker extends HTMLElement{
  constructor(){
    super();
    this.variantMainData = JSON.parse(this.getAttribute('data-variant-main'));
    this.productMainId = this.getAttribute('main-product-id');
    this.optionProductVariants = this.getOptionProductVariants();
    
    this.priceElements = this.getPriceElements();

    
    
    if(this.tagName == 'SUPER-VARIANT-PICKER'){
      //主产品选择当前url正确的变体选项
      const variant_id_Inurl = this.getQueryFromUrl('variant');
      if(!variant_id_Inurl){
        this.selectFirstOption();
      }else{
        const main_variant_data = this.variantMainData;
        this.updateSelectorMain(variant_id_Inurl,main_variant_data);
      }
      
      this.productMainVariant = this.getMainProductVariant();
      //获得当前选中的主要产品变体
      this.mainProductCurrentSelect={
        p_id : this.productMainId,
        variant_id : this.productMainVariant.id,
        variant_price:this.productMainVariant.price,
        variant_price_compare:this.productMainVariant.compare_at_price ? this.productMainVariant.compare_at_price : 0,
      }
    };
    
  }
  
  //元素添加至页面执行
  connectedCallback() {
    this.addEventListener('change', this.handlePickerChange.bind(this));
  }

  handlePickerChange(event) {
    if (!event.target || !event.target.matches('.non-standard-option select, .dimensions-selector-item select')) return;
    window.requestAnimationFrame(() => {
      this.getPriceElements().forEach(element => {
        element.updatePrice();
        element.updateBadge();
      });
    });
  }

  getQueryFromUrl(query) {
    // 获取当前URL
    const url = new URL(window.location);
  
    // 获取参数的值
    return url.searchParams.get(query);
  }

  selectFirstOption(){
    const selects = document.querySelectorAll(`custom-selector[option-type='main-product']`);
    selects.forEach(select=>select.querySelector('.selector-item').classList.add('is-selected'));
  }

  updateSelectorMain(variant_id,variant_data){
    const selecteds = document.querySelectorAll(`custom-selector[option-type='main-product'] .selector-item.is-selected`);
    selecteds.forEach(selected=>selected.classList.remove('is-selected'));
    let hasGetUrlVariant = false;
    variant_data.forEach(el=>{
      if(el.id==variant_id){
        hasGetUrlVariant = true;
        const options = el.options;
        options.forEach(option=>{
          option = option.replace(/"/g, '');
          document.querySelector(`custom-selector[option-type='main-product'] .selector-item[value='${option}']`).classList.add("is-selected");
        })
      }
    })
    if(!hasGetUrlVariant){
      this.selectFirstOption();
    }
  }
  
  isArrEqual(arr1, arr2){
    const arr2_new = arr2.map(el=>{
      el = el.replace(/"/g,'')
      return el
    })
    return arr1.length === arr2_new.length && arr1.every((ele) => arr2_new.includes(ele));
  };

  getPriceElements(){
    return document.querySelectorAll("price-total");
  }

  getMainProductId(){
    const data = this.getAttribute('main-product-id');
    return data;
  }

  getMainVariantData(){
    const data = JSON.parse(this.getAttribute('data-variant-main'));
    return data;
  }

  getMainProdctOptions(){
    let options=[];
    document.querySelectorAll("custom-selector[option-type='main-product']").forEach(el=>{
      options.push(el.querySelector(".is-selected").getAttribute("value"));
    });
    return options
  }

  getMainProductVariant(){
    const options = this.getMainProdctOptions();
    let variantMainCurrent = '';
    try{
      const variantData = this.variantMainData;
      if(!variantData) return;
      variantData.forEach(variant_obj=>{
        const isCurrentVariant = this.isArrEqual(options,variant_obj.options)
        if(isCurrentVariant){
          variantMainCurrent = variant_obj;
          throw new Error('breakForloop')
        }
      });
    }catch(e){
      if(e.message !== 'breakForloop') throw e
    }
    return variantMainCurrent;
  }

  computedMainProductVariant(option){
    let options=[];
    options.push(option);
    document.querySelectorAll("custom-selector[option-type='main-product']").forEach(el=>{
      let noBelongSelector = false;
      el.querySelectorAll('.selector-item').forEach(item=>{
        if(item.getAttribute('value')==option){
          noBelongSelector = true;
        }
      });
      if(!noBelongSelector){
        options.push(el.querySelector(".is-selected").getAttribute("value"));
      }
    });
    let variantMainCurrent = '';
    try{
      const variantData = this.variantMainData;
      if(!variantData) return;
      variantData.forEach(variant_obj=>{
        const isCurrentVariant = this.isArrEqual(options,variant_obj.options)
        if(isCurrentVariant){
          variantMainCurrent = variant_obj;
          throw new Error('breakForloop')
        }
      });
    }catch(e){
      if(e.message !== 'breakForloop') throw e
    }
    return variantMainCurrent;
  }

  getOptionProductVariants(){
    let variants = [];
    this.querySelectorAll('[option-type="option-product"]').forEach(el=>{
      if(!el.querySelector('.standard-option') && !el.querySelector('.non-standard-option')){
        const selected = el.querySelector('.is-selected');
        variants.push(
          {
            product_id:selected.getAttribute('data-product'),
            variant_id:selected.getAttribute('value'),
            variant_price:selected.getAttribute('data-price'),
            variant_compare_price:selected.getAttribute('data-compare-price'),
          }
        )
      }
    });
    return variants;
  }

  computedOptionProductVariants(currentSelector,optionValue){
    let variants = [];
    this.querySelectorAll('[option-type="option-product"]').forEach(el=>{
      if(!el.querySelector('.standard-option') && !el.querySelector('.non-standard-option')){
        if(currentSelector == el){
          const unSelected = el.querySelector(`[value="${optionValue}"]`);
          if(unSelected){
            variants.push(
              {
                product_id:unSelected.getAttribute('data-product'),
                variant_id:unSelected.getAttribute('value'),
                variant_price:unSelected.getAttribute('data-price'),
                variant_compare_price:unSelected.getAttribute('data-compare-price'),
              }
            )
          }
        }else{
          const selected = el.querySelector('.is-selected');
          variants.push(
            {
              product_id:selected.getAttribute('data-product'),
              variant_id:selected.getAttribute('value'),
              variant_price:selected.getAttribute('data-price'),
              variant_compare_price:selected.getAttribute('data-compare-price'),
            }
          )
        }
        
      }
    });
    return variants;
  }

  getDimensionProductVariants(){
    let variants = [];
    //标准尺寸选项变体
    //console.log(this.querySelectorAll('.standard-option [data-variants]'));
    if(this.querySelectorAll('.standard-option [data-variants]').length>0){
      const standardOptions = this.querySelectorAll('.standard-option [data-variants]');
      standardOptions.forEach(el=>{
        const variantsData = JSON.parse(el.getAttribute("data-variants"));
        if(el.classList.contains('is-selected')){
          variants.push(
            {
              product_id:el.getAttribute('data-product'),
              variant_id:el.getAttribute('value'),
              variant_price:el.getAttribute('data-price'),
              variant_compare_price:el.getAttribute('data-compare-price'),
            }
          )
        }
        
      });
      return variants;
    }
    //非标准尺寸选项变体
    const nonStandardOptions = this.querySelectorAll('.non-standard-option [data-variants]');
    nonStandardOptions.forEach(el=>{
      const variantsData = JSON.parse(el.getAttribute("data-variants"));
      const productId = el.getAttribute("data-product");
      const currentOptionValue = el.querySelector('select').value;
      variantsData.forEach(variant=>{
        variant.options.forEach(option=>{
          if(option==currentOptionValue){
            variants.push(
              {
                product_id:productId,
                variant_id:variant.id,
                variant_price:variant.price,
                variant_compare_price:variant.compare_at_price
              }
            )
          }
        })
      })
    });
    return variants;
    
  }


  
  
}

//注册组件
customElements.define('super-variant-picker',SuperVariantPicker);


class customSelector extends HTMLElement{
  constructor(){
    super();
    this.optionType = this.getAttribute("option-type");
    this.variantPicker = this.getVariantPickerElement();
    this.colorSwatch = this.getAttribute("color-swatch");    

    //只显示当前颜色图片
    if(this.colorSwatch=='true'){
      //this.showCurrentImg(this.querySelector(".is-selected").getAttribute("value"));
      this.switch_featured_img(this.variantPicker.getMainVariantData(),this.querySelector(".is-selected").getAttribute("value"));
    }


    
    this.addEventListener("click",(event)=>{
      this.event = event;
      const selectorItem = event.target.closest(".selector-item");
      if (!selectorItem || !this.contains(selectorItem)) return;
      if (selectorItem.classList.contains("is-disabled") || selectorItem.getAttribute("aria-disabled") === "true") return;

      const priceElements = this.getPriceElements();
      if(selectorItem.classList.contains('is-selected')) return;
      const currentItem = this.querySelector(".is-selected");
      if (currentItem) currentItem.classList.remove('is-selected');
      selectorItem.classList.add('is-selected');
        
        //更新选择的变体
      if(this.optionType == 'main-product'){
        const currentVariant = this.variantPicker.getMainProductVariant();
        this.variantPicker.mainProductCurrentSelect={
          p_id : this.variantPicker.productMainId,
          variant_id : currentVariant.id,
          variant_price:currentVariant.price,
          variant_price_compare:currentVariant.compare_at_price ? currentVariant.compare_at_price : 0,
        }
          // this.mainProductCurrentSelect={
          //   p_id : this.variantPicker.productMainId,
          //   variant_id : currentVariant.id,
          //   variant_price:currentVariant.price,
          //   variant_price_compare:currentVariant.compare_at_price ? currentVariant.compare_at_price : 0,
          // }
          
        this.updateVariantInUrl(currentVariant.id);
      }
      if(this.optionType == 'option-product'){
        this.querySelector("input").value = selectorItem.getAttribute("value");
      }

      //update price
      priceElements.forEach(el=>{
        el.updatePrice();
        el.updateBadge();
      });

      //切换颜色图片
      if(this.colorSwatch == 'true'){
        //this.showCurrentImg(this.querySelector(".is-selected").getAttribute("value"));
        this.switch_featured_img(this.variantPicker.getMainVariantData(),this.querySelector(".is-selected").getAttribute("value"));
      }
      
    });
  }

  selectFirstOption(){
    const selects = document.querySelectorAll(`custom-selector[option-type='main-product']`);
    selects.forEach(select=>select.querySelector('.selector-item').classList.add('is-selected'));
  }

  updateSelectorMain(variant_id,variant_data){
    const selecteds = document.querySelectorAll(`custom-selector[option-type='main-product'] .selector-item.is-selected`);
    selecteds.forEach(selected=>selected.classList.remove('is-selected'));
    variant_data.forEach(el=>{
      if(el.id==variant_id){
        const options = el.options;
        options.forEach(option=>{
          option = option.replace(/"/g, '');
          document.querySelector(`custom-selector[option-type='main-product'] .selector-item[value='${option}']`).classList.add("is-selected");
          // const items = document.querySelectorAll(`custom-selector[option-type='main-product'] .selector-item`);
          // items.forEach(item=>{
          //   console.log(item.getAttribute("value"),option);
          //   if(item.getAttribute("value")==option){
          //     item.classList.add("is-selected");
          //   }
          // });
        })
      }
    })
  }

  getQueryFromUrl(query) {
    // 获取当前URL
    const url = new URL(window.location);
  
    // 获取参数的值
    return url.searchParams.get(query);
  }
  
  updateVariantInUrl(id) {
    // 获取当前URL
    const url = new URL(window.location);
  
    // 设置或更新 'variant' 参数的值
    url.searchParams.set('variant', id);
  
    // 使用新URL替换当前的URL，不刷新页面
    window.history.replaceState({}, '', url);
  }
  
  showCurrentImg(option_value){
    document.querySelectorAll("[data-product-single-media-wrapper]").forEach(el=>{
      const imgAlt = el.querySelector('img[data-master]').getAttribute('alt');
      if(imgAlt != option_value){
        el.setAttribute("aria-hidden","true");
      }else{
        el.setAttribute("aria-hidden","false");
      }
    })
    
    document.querySelectorAll("[data-thumb__scroller] [data-grname]").forEach(el=>{
      const imgAlt = el.querySelector('img[src]').getAttribute('alt');
      if(imgAlt != option_value){
        el.style.display = 'none';
      }else{
        el.style.display = 'block';
      }
    })
  }

  switch_featured_img(variant_obj,option_value){
    // Gallery V2 owns media state through the selected variant's media ID.
    // Keep the existing variant/price controller running, but do not let the
    // legacy Flickity synchronizer query or mutate V2 media markup.
    const productRoot = this.closest('[data-product-featured]');
    const galleryV2 = productRoot && productRoot.querySelector('mcocod-product-gallery-v2');
    if(galleryV2){
      const matchedVariant = variant_obj.find(variant =>
        variant.public_title &&
        variant.public_title.includes(option_value) &&
        variant.featured_image &&
        variant.featured_image.src
      );

      if(matchedVariant && typeof galleryV2.setActive === 'function'){
        const normalizeMediaSrc = (src) => String(src || '')
          .replace(/^https?:/, '')
          .split('?')[0];
        const variantImgSrc = normalizeMediaSrc(matchedVariant.featured_image.src);
        const targetSlide = Array.from(galleryV2.querySelectorAll('[data-gallery-slide][data-media-type="image"]')).find(slide => {
          const imageButton = slide.querySelector('[data-gallery-image-button]');
          const image = slide.querySelector('img');
          const slideImgSrc = normalizeMediaSrc(
            (imageButton && imageButton.getAttribute('data-master')) ||
            (image && (image.getAttribute('data-master') || image.getAttribute('src')))
          );
          return slideImgSrc && (slideImgSrc.includes(variantImgSrc) || variantImgSrc.includes(slideImgSrc));
        });

        if(targetSlide){
          galleryV2.setActive(targetSlide.getAttribute('data-gallery-media-id'), {
            userInitiated: false,
            focusThumb: false
          });
        }
      }
      return;
    }

    variant_obj.forEach(variant=>{
      
      const variantImgSrc = variant.featured_image ? variant.featured_image.src : null;
      document.querySelectorAll('.t4s-carousel__nav-item[data-mdtype="image"]').forEach(el=>{
        const img_src = el.querySelector('img[src]').getAttribute('src');
        if(img_src.includes(variantImgSrc)){
          el.style.display="none";
        }
      })

      
      //old code
      if(variant.public_title.includes(option_value)){
        const variantImgSrc = variant.featured_image ? variant.featured_image.src : null;
        if(variantImgSrc != ''){
          if(!variantImgSrc){
            return 
          }
          document.querySelectorAll("[data-product-single-media-wrapper]").forEach(el=>{
            const img_src = el.querySelector('img[data-master]').getAttribute('data-master');
            if(el.classList.contains('is-selected')){
              el.classList.remove("is-selected");
            };
            if(img_src.includes(variantImgSrc)){
              el.classList.add("is-selected");
            }
          });
          document.querySelectorAll('.t4s-carousel__nav-item[data-mdtype="image"]').forEach(el=>{
            const img_src = el.querySelector('img[src]').getAttribute('src');
            if(el.classList.contains('is-nav-selected')){
              el.classList.remove("is-nav-selected");
            };
            if(img_src.includes(variantImgSrc)){
              el.classList.add("is-nav-selected");
              el.style.display="block";
            }
          });

        }
      }
      
    });
  }
  
  //get variant picker component
  getVariantPickerElement(){
    return document.querySelector("super-variant-picker");
  }

  getPriceElements(){
    return document.querySelectorAll("price-total");
  }



  
}
customElements.define('custom-selector',customSelector)


//切换尺寸类型组件
class SwitchDimensionsType extends HTMLElement{

  constructor(){
    super();
    this.standardHtml = standardHtml;
    this.nonStandardHtml = nonStandardHtml;
    if(this.querySelector(".is-actived").getAttribute('value')=='Standard Dimensions'){
      if(document.querySelector("#virtual-dom")){
        document.querySelector("#virtual-dom").classList.remove("non-standard-option");
        document.querySelector("#virtual-dom").classList.add("standard-option");
        document.querySelector("#virtual-dom").innerHTML = this.standardHtml;
      }
    }else if(this.querySelector(".is-actived").getAttribute('value')=='Non-standard Dimensions'){
      if(document.querySelector("#virtual-dom")){
        document.querySelector("#virtual-dom").classList.remove("standard-option");
        document.querySelector("#virtual-dom").classList.add("non-standard-option");
        document.querySelector("#virtual-dom").innerHTML = this.nonStandardHtml;
      }
    }
    
    this.addEventListener('click',event=>{
      this.updateDimensionsSelector(event);
    })
    
  }

  updateDimensionsSelector(event){
    if(event.target.classList.contains("dimensions-type-options-value")){
      if(!event.target.classList.contains("is-actived")){
        this.querySelector(".dimensions-type-options-value.is-actived").classList.remove("is-actived");
        event.target.classList.add("is-actived");
        
        let insertHTML = '';
        let className = '';
        if(event.target.getAttribute('value')=='Standard Dimensions'){
          className = 'standard-option';
          insertHTML = this.standardHtml;
        }else if(event.target.getAttribute('value')=='Non-standard Dimensions'){
          className = 'non-standard-option';
          insertHTML = this.nonStandardHtml;
        }
        if(insertHTML != ''){
          if(document.querySelector("#virtual-dom")){
            document.querySelector("#virtual-dom").classList.remove("non-standard-option");
            document.querySelector("#virtual-dom").classList.remove("standard-option");
            document.querySelector("#virtual-dom").classList.add(className);
            document.querySelector("#virtual-dom").innerHTML = insertHTML;
          }else{
            console.error(`document.querySelector("#virtual-dom") not find`);
          }
          
        }
        
      }
    }    
  }
  
  
}

customElements.define("switch-dimensions-type",SwitchDimensionsType)

//价格组件
class PriceTotal extends HTMLElement{
  
  static observedAttributes = ['data-products','data-option-main','data-option-dimensions','data-option-color','data-option-protected','data-option-glassColor','data-option-install','data-option-door-handle'];
  
  constructor(){
    super();
    this.updatePrice();
    this.updateBadge();
  }

  getVariantPickerElement(){
    return document.querySelector("super-variant-picker");
  }
  
  getOptionsPrice(optionVariants){
    let price = 0;
    let comparePrice = 0;
    optionVariants.forEach(el=>{
      price = Number(price) + Number(el.variant_price);
      comparePrice = Number(comparePrice) + Number(el.variant_compare_price);
    });
    return {
      price:price,
      comparePrice:comparePrice
    }
  }

  getMainPrice(variant){
    return {
      price:Number(variant.price),
      comparePrice:Number(variant.compare_at_price)
    }
  };

  getDimensionPrice(dimensionVariants){
    let price = 0;
    let comparePrice = 0;
    dimensionVariants.forEach(el=>{
      price = price + Number(el.variant_price);
      comparePrice =comparePrice + Number(el.variant_compare_price);
    });
    
    return {
      price:price,
      comparePrice:comparePrice
    }
  }

  getPrice(optionVariants,mainVariant,dimensionVariants){
    const optionsPrice = this.getOptionsPrice(optionVariants);
    const mainPrice = this.getMainPrice(mainVariant);
    const dimensionsPrice = this.getDimensionPrice(dimensionVariants);
    return {
      totalPrice: optionsPrice.price + mainPrice.price + dimensionsPrice.price,
      totalComparePrice:optionsPrice.comparePrice + mainPrice.comparePrice + dimensionsPrice.comparePrice
    }
  }

  formatPrice(price){
    return `$${price/100}`
  }

  formatNeedPrice(price){
    if(price<0){
      return `-$${Math.abs(price/100)}`
    }else{
      return `+$${Math.abs(price/100)}`
    }
     
  }

  updatePrice(){
    this.salePriceElement = this.querySelector('.sale-price');
    this.comparePriceElement = this.querySelector('.compare-price');
    this.variantPicker = this.getVariantPickerElement();
    this.price = this.getPrice(this.variantPicker.getOptionProductVariants(),this.variantPicker.getMainProductVariant(),this.variantPicker.getDimensionProductVariants());
    this.setAttribute("sale-price",this.price.totalPrice);
    const salePrice =  this.price.totalPrice;
    const comparePrice = this.price.totalComparePrice;
    if(comparePrice>salePrice){
      this.comparePriceElement.innerHTML = this.formatPrice(comparePrice);
    }
    this.salePriceElement.innerHTML = this.formatPrice(salePrice);
  }


  updateBadge(){
    this.variantPicker = this.getVariantPickerElement();
    const selectors = this.variantPicker.querySelectorAll('[data-badge="true"]');
    selectors.forEach(el=>{
      let variantData = [];
      el.querySelectorAll('.selector-item').forEach(element=>{
        if(!element.classList.contains("is-selected")){
          const optionValue = element.getAttribute("value");
          variantData.push(optionValue);
          if(el.getAttribute("option-type") == 'main-product' ){
            //计算主产品价格
            const currentPrice = this.price.totalPrice;
            const price = this.getPrice(this.variantPicker.getOptionProductVariants(),this.variantPicker.computedMainProductVariant(optionValue),this.variantPicker.getDimensionProductVariants());
            const computedPrice =  price.totalPrice;
            const needPrice = computedPrice - currentPrice ;
            element.setAttribute("data-dynamic-price",this.formatNeedPrice(needPrice));
          }
          if(el.getAttribute("option-type")=='option-product' && !el.querySelector('.standard-option') && !el.querySelector('.non-standard-option')){
            const variantId = element.getAttribute("value");
            variantData.push(
              {
                product_id:element.getAttribute("data-product"),
                variant_id:element.getAttribute("value"),
                variant_price:element.getAttribute("data-price"),
                variant_compare_price:element.getAttribute("data-compare-price")
              }
            )
            //计算变体产品价格
            const currentPrice = this.price.totalPrice;
            const price = this.getPrice(this.variantPicker.computedOptionProductVariants(el,optionValue),this.variantPicker.getMainProductVariant(),this.variantPicker.getDimensionProductVariants());
            const computedPrice =  price.totalPrice;
            const needPrice = computedPrice - currentPrice;
            if(element.classList.contains("is-selected")){
              element.setAttribute("data-dynamic-price","");
            }else{
              element.setAttribute("data-dynamic-price",this.formatNeedPrice(needPrice));
            }
          }
        }else{
          element.setAttribute("data-dynamic-price","");
        }
      });
      return variantData;
    })
  }
  
  
  attributeChangedCallback(name, oldVal, newVal) {
    // console.log(
    //   `Attribute ${name} has changed from ${oldVal} to ${newVal}.`,
    // );
    this[name] = newVal;
  }


  
}

customElements.define('price-total',PriceTotal);




/* ============================================================
   加购按钮"一直转圈"修复
   适用主题文件：assets/custom.js
   操作：把下面这一整段，粘贴到 custom.js 的【最末尾】即可（在文件最后一行之后）。
   原理：
     1) 覆盖 SuperBuy 的 addToCard 方法，把原来"主商品+尺寸项+选项项"
        拆成十几个 /cart/add.js 请求，合并成【一个】请求提交，避免触发
        Shopify 边缘的机器人/限速挑战（就是那个返回 429 的原因）。
     2) 用 try...finally 兜底：无论成功或失败，都会执行 this.loaded() 把
        转圈关掉；并检查 response.ok，请求失败时不会再无限转圈。
   注意：不改动其他任何代码；原来的 addToCard / addCart 保留不动，
        这里只是在运行时覆盖 addToCard 的行为。
   ============================================================ */
SuperBuy.prototype.addToCard = async function (event, buyNow = false) {
  const btn = event.currentTarget;
  try {
    const mainProductSelected = this.variantPicker.mainProductCurrentSelect,
          dimensionSelected = this.variantPicker.getDimensionProductVariants(),
          optionSelected = this.variantPicker.getOptionProductVariants();
    const quality = this.getQualityElement().input.value,
          time = new Date().getTime();

    // 把所有要加的项收进一个数组，只发一次请求
    const items = [{
      id: mainProductSelected.variant_id,
      quantity: quality,
      properties: { type: "product", _cart_id: time }
    }];
    for (const item of dimensionSelected) {
      items.push({ id: item.variant_id, quantity: quality, properties: { type: "option", _cart_id: time } });
    }
    for (const item of optionSelected) {
      items.push({ id: item.variant_id, quantity: quality, properties: { type: "option", _cart_id: time } });
    }

    const res = await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: items })
    });

    if (!res.ok) {
      let msg = "cart/add failed: " + res.status;
      try {
        const err = await res.clone().json();
        if (err && err.description) msg = err.description;
      } catch (e) {}
      throw new Error(msg);
    }

    this.loaded(btn);
    await this.getCart();
    if (!buyNow) {
      try {
        await this.getCartElement();
      } catch (drawerErr) {
        try {
          const c = await this.getCart();
          const n = c.items.filter(i => i.properties && i.properties.type === "product").length;
          document.querySelectorAll("[data-cart-count]").forEach(el => { el.innerHTML = n; });
        } catch (e2) {}
      }
    }
  } catch (e) {
    console.error("[SuperBuy addToCard] 加购失败：", e);
  } finally {
    this.loaded(btn); // 无论成功失败，转圈都会停
  }
};

/* 修复：加购后购物车抽屉改用主题原生方式打开，解决"抽屉打开后页面无法滚动/关不掉" */
SuperBuy.prototype.openMiniCart = async function (el) {
  try {
    const cart = await this.getCart();
    const n = cart.items.filter(i => i.properties && i.properties.type === "product").length;
    document.querySelectorAll("[data-cart-count], [data-cart-count-1]").forEach(c => {
      c.innerHTML = n;
      if (n > 0) c.classList.remove("t4s-op-0");
    });
  } catch (e) {}
  const $ = window.jQuery || window.$;
  if (el && $ && window.T4SThemeSP && window.T4SThemeSP.Drawer) {
    window.T4SThemeSP.Drawer.opend($(el));
  } else if (el) {
    el.setAttribute("aria-hidden", "false");
  }
};

/* 购物车关闭后的滚动锁兜底：删除商品会重绘抽屉内容，主题的 transitionend
   偶发丢失，导致 body 保留锁滚动 class。只在没有其他抽屉打开时恢复页面滚动。 */
(function () {
  function unlockPageScroll(drawer) {
    if (!drawer || drawer.getAttribute("aria-hidden") !== "true") return;
    if (document.querySelector(".t4s-drawer[aria-hidden=\"false\"]")) return;

    document.body.classList.remove("t4s-lock-scroll", "is--opend-drawer");
    document.documentElement.classList.remove("t4s-lock-scroll", "is--opend-drawer");
    document.documentElement.style.removeProperty("margin-right");

    var overlay = document.querySelector(".t4s-close-overlay");
    if (overlay) overlay.classList.remove("is--visible");

    if (window.T4SThemeSP && window.T4SThemeSP.Helpers) {
      window.T4SThemeSP.Helpers.disableBodyScroll(false, "[data-t4s-scroll-me]");
    }
  }

  function bind() {
    var drawer = document.querySelector("#t4s-mini_cart");
    if (!drawer) return;
    var observer = new MutationObserver(function () {
      if (drawer.getAttribute("aria-hidden") === "true") {
        unlockPageScroll(drawer);
        window.setTimeout(function () { unlockPageScroll(drawer); }, 650);
      }
    });
    observer.observe(drawer, { attributes: true, attributeFilter: ["aria-hidden"] });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", bind);
  else bind();
})();

/* 购物车抽屉打开时，让 Shopify Inbox 客服按钮避让，避免遮住小计价格；关闭时复原 */
(function () {
  function bind(tries) {
    var drawer = document.querySelector('#t4s-mini_cart');
    if (!drawer) { if ((tries || 0) < 10) setTimeout(function(){ bind((tries||0)+1); }, 500); return; }
    function sync() {
      var chat = document.querySelector('shopify-chat');
      if (!chat) return;
      var open = drawer.getAttribute('aria-hidden') === 'false';
      chat.style.transition = 'transform .25s ease, opacity .2s ease';
      if (!open) { chat.style.transform = ''; chat.style.opacity = ''; chat.style.pointerEvents = ''; return; }
      var w = drawer.getBoundingClientRect().width || 340;
      if (w > window.innerWidth * 0.8) {
        chat.style.opacity = '0'; chat.style.pointerEvents = 'none'; chat.style.transform = '';
      } else {
        chat.style.opacity = ''; chat.style.pointerEvents = '';
        chat.style.transform = 'translateX(-' + (w + 24) + 'px)';
      }
    }
    new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ bind(0); });
  else bind(0);
})();

/* 手机端购物车抽屉内容区无法滚动修复：flex 链补 min-height:0，约束滚动容器 + 开启触摸惯性滚动 */
(function () {
  var css =
    "#t4s-mini_cart .t4s-drawer__wrap,#t4s-mini_cart .t4s-drawer__main{min-height:0}" +
    "#t4s-mini_cart .t4s-drawer__main .t4s-drawer__scroll{min-height:0;-webkit-overflow-scrolling:touch}";
  var s = document.createElement("style");
  s.id = "mc-scroll-fix";
  s.textContent = css;
  document.head.appendChild(s);
})();

/* 购物车有商品时隐藏"空购物车占位块"，避免抽屉里出现多余空白（基于是否存在商品分组，规避时机问题）*/
(function () {
  var css = "#t4s-mini_cart .t4s-drawer__scroll:has(.custom-mini-cart-item) .t4s-when-cart-emty{display:none!important}";
  var s = document.createElement("style");
  s.id = "mc-empty-fix";
  s.textContent = css;
  document.head.appendChild(s);
})();

/* 移动端购买入口：价格区离开视口后显示，始终复用现有配置与加购按钮。 */
(function () {
  function bind() {
    var dock = document.querySelector("[data-mcocod-sticky-button]")?.closest("#mcocod-mobile-sticky-atc");
    var mainButton = document.querySelector(".t4s-section-main-product .button-add-to-card");
    var priceArea = document.querySelector(".t4s-section-main-product .t4s-product__price-review") ||
      document.querySelector(".t4s-section-main-product price-total");
    var picker = document.querySelector(".t4s-section-main-product super-variant-picker");
    if (!dock || !mainButton || !priceArea || !picker) return;

    var stickyButton = dock.querySelector("[data-mcocod-sticky-button]");
    var stickyLabel = dock.querySelector("[data-mcocod-sticky-label]");
    var stickySummary = dock.querySelector("[data-mcocod-sticky-summary]");
    var stickyPrice = dock.querySelector("[data-mcocod-sticky-price]");
    var stickyStatus = dock.querySelector("[data-mcocod-sticky-status]");
    var addToCartLabel = "Add to cart";
    var selectOptionsLabel = "Select options";
    var lastAnnouncedStatus = "";

    function selectors() {
      return Array.from(picker.querySelectorAll('custom-selector[option-type="main-product"], custom-selector[option-type="option-product"]'));
    }

    function selectedItem(selector) {
      return selector.querySelector(".selector-item.is-selected");
    }

    function selectedText(selector) {
      var item = selectedItem(selector);
      if (!item) return "";
      var title = item.querySelector(".option-title");
      return (title ? title.textContent : item.textContent || "").replace(/\s+/g, " ").trim();
    }

    function getState() {
      var missing = null;
      var values = [];
      selectors().forEach(function (selector) {
        var isDimension = selector.querySelector(".standard-option, .non-standard-option");
        var selected = selectedItem(selector);
        if (isDimension && selector.querySelector(".standard-option") && !selected) {
          missing = missing || selector;
        } else if (!isDimension && !selected) {
          missing = missing || selector;
        }
        var value = selectedText(selector);
        if (value) values.push(value);
      });
      return { missing: missing, summary: values.slice(0, 2).join(" · ") };
    }

    function currentPrice() {
      var price = document.querySelector(".t4s-section-main-product price-total .sale-price, .t4s-section-main-product price-total .price");
      return price && price.textContent.trim() ? price.textContent.trim() : "";
    }

    function syncLoading() {
      var spinner = mainButton.querySelector(".loading");
      var loading = spinner && !spinner.classList.contains("hidden");
      dock.classList.toggle("is-loading", !!loading);
      stickyButton.disabled = !!loading;
      return !!loading;
    }

    function syncState() {
      var state = getState();
      stickySummary.textContent = state.summary || selectOptionsLabel;
      var price = currentPrice();
      if (price) stickyPrice.textContent = price;
      if (state.missing) {
        stickyLabel.textContent = selectOptionsLabel;
        stickyButton.removeAttribute("data-ready");
      } else {
        stickyLabel.textContent = addToCartLabel;
        stickyButton.setAttribute("data-ready", "true");
      }
      var statusMessage = state.missing ? "Options needed. Select options." : "Options complete. Add to cart.";
      if (stickyStatus && dock.classList.contains("is-visible") && statusMessage !== lastAnnouncedStatus) {
        stickyStatus.textContent = statusMessage;
        lastAnnouncedStatus = statusMessage;
      }
      syncLoading();
    }

    function focusMissing(selector) {
      var target = selector.querySelector('.selector-item:not(.is-disabled):not([aria-disabled="true"])') || selector.querySelector(".mcocod-step-title") || selector;
      var reducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      target.setAttribute("tabindex", "-1");
      target.scrollIntoView({ block: "center", behavior: reducedMotion ? "auto" : "smooth" });
      window.setTimeout(function () {
        target.focus({ preventScroll: true });
        target.classList.add("mcocod-sticky-focus");
        window.setTimeout(function () { target.classList.remove("mcocod-sticky-focus"); }, 900);
      }, reducedMotion ? 0 : 180);
    }

    stickyButton.addEventListener("click", function () {
      var state = getState();
      if (syncLoading()) return;
      if (state.missing) {
        focusMissing(state.missing);
        return;
      }
      dock.classList.add("is-loading");
      stickyButton.disabled = true;
      mainButton.click();
      window.setTimeout(syncLoading, 12000);
    });

    mainButton.addEventListener("click", function () {
      dock.classList.add("is-loading");
      stickyButton.disabled = true;
    });

    var mutationObserver = new MutationObserver(function () {
      syncState();
    });
    mutationObserver.observe(picker, { subtree: true, attributes: true, attributeFilter: ["class", "value"] });
    mutationObserver.observe(document.querySelector(".t4s-section-main-product price-total") || picker, { subtree: true, childList: true, characterData: true });

    var mainButtonLoadingObserver = new MutationObserver(function () {
      syncLoading();
    });
    mainButtonLoadingObserver.observe(mainButton, { subtree: true, attributes: true, attributeFilter: ["class"] });

    function syncDockVisibility() {
      var rect = priceArea.getBoundingClientRect();
      var visible = rect.top < window.innerHeight && rect.bottom > 0;
      var passedPriceArea = rect.bottom <= 0;
      var distanceToBottom = document.documentElement.scrollHeight - window.scrollY - window.innerHeight;
      var atPageEnd = distanceToBottom <= 120;
      var activeElement = document.activeElement;
      var keyboardTarget = activeElement && /INPUT|TEXTAREA|SELECT/.test(activeElement.tagName);
      var overlayOpen = document.querySelector(
        '.t4s-drawer[aria-hidden="false"], [role="dialog"][aria-modal="true"]:not([hidden]), .t4s-popup-modal[aria-hidden="false"]'
      );
      if (visible || !passedPriceArea || atPageEnd || overlayOpen || keyboardTarget) {
        dock.classList.remove("is-visible");
        dock.setAttribute("hidden", "hidden");
        document.body.classList.remove("mcocod-mobile-sticky-active");
      } else {
        dock.removeAttribute("hidden");
        dock.classList.add("is-visible");
        document.body.classList.add("mcocod-mobile-sticky-active");
      }
    }

    var visibilityObserver = new IntersectionObserver(syncDockVisibility, { threshold: [0, 0.08] });
    visibilityObserver.observe(priceArea);
    var cartDrawer = document.querySelector("#t4s-mini_cart");
    if (cartDrawer) {
      new MutationObserver(syncDockVisibility).observe(cartDrawer, { attributes: true, attributeFilter: ["aria-hidden"] });
    }
    window.addEventListener("scroll", syncDockVisibility, { passive: true });
    window.addEventListener("resize", syncDockVisibility, { passive: true });
    document.addEventListener("focusin", syncDockVisibility);
    document.addEventListener("focusout", function () { window.setTimeout(syncDockVisibility, 0); });
    document.addEventListener("click", function () { window.setTimeout(syncDockVisibility, 0); });

    picker.addEventListener("click", function () { window.setTimeout(syncState, 0); });
    syncState();
    syncDockVisibility();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", bind);
  else bind();
})();

/* 删除购物车商品修复：把一组行项的删除合并成一个 cart/update.js 请求（避免请求storm触发风控），并加兜底关闭转圈，解决"删除时一直转圈卡住" */
(function () {
  if (typeof RemoveCart === "undefined") return;
  function buildUpdates(items, cartId) {
    var updates = {};
    items.forEach(function (item) {
      if (item.properties && item.properties._cart_id == cartId) updates[item.key] = 0;
    });
    return updates;
  }
  function hideSpinners() {
    document.querySelectorAll(".mini-cart-loading").forEach(function (el) { el.classList.add("hidden"); });
  }
  async function removeGroup(self, cartId, refreshFnName) {
    try {
      var carts = await self.getCart();
      var updates = buildUpdates(carts.items, cartId);
      if (Object.keys(updates).length) {
        var res = await fetch(window.Shopify.routes.root + "cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates: updates })
        });
        if (!res.ok) throw new Error("cart/update failed: " + res.status);
      }
      if (typeof self[refreshFnName] === "function") await self[refreshFnName]();
    } catch (e) {
      console.error("[RemoveCart] 删除失败：", e);
      hideSpinners();
    }
  }
  RemoveCart.prototype.removeCart = function (cartId) { return removeGroup(this, cartId, "getCartElement"); };
  RemoveCart.prototype.removeMainCart = function (cartId) { return removeGroup(this, cartId, "getMainCartElement"); };
})();

/* Shopify Inbox 聊天按钮恢复旧版样式（v2）：
   - 大蓝圆+白图标；手机端 48px，聊天与返回顶部共享避让位置
   - 去掉 hover 规则：修复 iOS 需要双击才能打开的问题
   - 面板打开时隐藏按钮：修复打开后按钮与面板重叠
   - 同时注入外层 shadow 和嵌套的 shopify-agent-runtime shadow（组件有两种渲染模式） */
(function () {
  var CSS = ".activator-nudge--right{bottom:var(--mcocod-floating-bottom,24px) !important;right:24px !important;}" +
    ".activator{background:#09418D !important;color:#FFFFFF !important;width:56px !important;height:56px !important;border-radius:50% !important;box-shadow:0 4px 14px rgba(0,0,0,.35) !important;}" +
    ".activator__icon{color:#FFFFFF !important;width:26px !important;height:26px !important;}" +
    ".activator[aria-expanded=\"true\"]{opacity:0 !important;pointer-events:none !important;}" +
    "@media (max-width:749px){.activator-nudge--right{right:16px !important;}.activator{width:48px !important;height:48px !important;}.activator__icon{width:22px !important;height:22px !important;}}";
  function addTo(root) {
    if (!root) return;
    if (!root.querySelector("#mc-chat-style")) {
      var st = document.createElement("style");
      st.id = "mc-chat-style";
      st.textContent = CSS;
      root.appendChild(st);
    }
  }
  function inject() {
    var chat = document.querySelector("shopify-chat");
    if (!chat || !chat.shadowRoot) return false;
    addTo(chat.shadowRoot);
    var rt = chat.shadowRoot.querySelector("shopify-agent-runtime");
    if (rt && rt.shadowRoot) addTo(rt.shadowRoot);
    return true;
  }
  if (!document.getElementById("mc-chat-offset")) {
    var os = document.createElement("style");
    os.id = "mc-chat-offset";
    os.textContent = "body{--mcocod-floating-bottom:calc(24px + env(safe-area-inset-bottom));}" +
      "@media(max-width:1024px){body.mcocod-mobile-sticky-active{--mcocod-floating-bottom:calc(var(--mcocod-mobile-sticky-height,72px) + 24px + env(safe-area-inset-bottom));}}" +
      "body #t4s-backToTop.t4s-back-to-top{width:56px;height:56px;right:24px;bottom:calc(var(--mcocod-floating-bottom) + 72px);border:2px solid #09418D;border-radius:50%;background:#FFFFFF;color:#09418D;box-shadow:0 4px 14px rgba(0,0,0,.35);}" +
      "body #t4s-backToTop.t4s-back-to-top:hover,body #t4s-backToTop.t4s-back-to-top:focus-visible{background:#09418D;border-color:#09418D;color:#FFFFFF;}" +
      "body #t4s-backToTop .t4s-circle-css,body #t4s-backToTop .t4s-circle--inner{border-radius:50%;background:transparent;}body #t4s-backToTop .t4s-circle--bg{display:none;}" +
      "body #t4s-backToTop svg{width:20px;height:20px;}" +
      "@media(max-width:749px){body #t4s-backToTop.t4s-back-to-top{width:48px;height:48px;right:16px;bottom:calc(var(--mcocod-floating-bottom) + 64px);}body #t4s-backToTop svg{width:18px;height:18px;}}";
    document.head.appendChild(os);
  }
  var tries = 0;
  var timer = setInterval(function () {
    tries++;
    if (inject() || tries > 60) clearInterval(timer);
  }, 500);
  setInterval(inject, 3000); // 常驻守护：组件重渲染/切换模式后自动补样式
})();
